// Module
var code = "<span class=\"x-form-fieldset-title\">{[L(\"ApproveScreen.ApprInvFromTitle\",\"Approve Invoice From\")]}:</span>\n\n<div class=\"approveExternalDocs-supplier-data card\">\n\n    <tpl include=\"app/widgets/templates/userDataTable/user-data-table.tpl.html\" data=\"values\"></tpl>\n\n</div>\n\n\n\n";
// Exports
module.exports = code;